import { importProfileData } from "../../lib/import/profileDataImport.js";
import { buildSampleProfileDataExport } from "./sampleProfileDataExport.js";

export async function loadSampleDataIntoNewProfile({
  language,
  now = new Date()
} = {}) {
  const payload = buildSampleProfileDataExport({
    language,
    now
  });

  return importProfileData(payload);
}
